/** Microsoft Forms — 학교 등록 요청 */
export const SCHOOL_REGISTRATION_FORM_URL =
  'https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAN__ixf8qhUMDVGODlWNEJZRlk4TDRXVEsyM0dWMjBJUy4u';
